import React, { createContext, useContext, useState, ReactNode } from 'react'

interface TutorialContextType {
  isTutorialActive: boolean
  setIsTutorialActive: (active: boolean) => void
  activeTutorialType: string | null
  setActiveTutorialType: (type: string | null) => void
}

const TutorialContext = createContext<TutorialContextType | undefined>(undefined)

export const useTutorialContext = () => {
  const context = useContext(TutorialContext)
  if (context === undefined) {
    throw new Error('useTutorialContext must be used within a TutorialProvider')
  }
  return context
}

interface TutorialProviderProps {
  children: ReactNode
}

export const TutorialProvider: React.FC<TutorialProviderProps> = ({ children }) => {
  const [isTutorialActive, setIsTutorialActive] = useState(false)
  const [activeTutorialType, setActiveTutorialType] = useState<string | null>(null)

  const value = {
    isTutorialActive,
    setIsTutorialActive,
    activeTutorialType,
    setActiveTutorialType,
  }

  return <TutorialContext.Provider value={value}>{children}</TutorialContext.Provider>
}
